module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAdElEQVRIS2NU2/z5PwMVwC1fXkZsxjDSzQJcLiDkOZgDCfpg1ILRIMKZmEZTEaF8xkD1ICK1aIGXRcTmZLpZAHMQriCCiZPtA5ItIBibBBSgBzGGD2hmAakGE0qWMPPgPhi1AFcIUBxExAYt1qYGPs2k5mQAiwmxnXr/ViwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/ju-left.png
// module id = 3HdW
// module chunks = 0